
import Vue from 'vue'
import Component from 'vue-class-component'
import {
    deviceList,
} from '@/api/device'
import { getDeviceTypeList, getSubDeviceTypeList, getDeviceTypeByParentId } from "@/api/deviceType";
import { updateEnableState } from "@/api/device";
import { getTcmBrainPassword } from "@/utils/common";

interface Device {
    id: number
    deviceName: string
    deviceCode: string
    deviceTypeName: string
    isEnable: boolean
    [key: string]: any
    // 其他字段
}

@Component({ name: 'h5-device-index' })
export default class H5DeviceManager extends Vue {
    devices: Device[] = []

    searchKeyType = "storeShowName"
    searchKeyword = ''
    
    deviceNameId = ''
    deviceTypeId = ''

    isEnable: number | null = null

    deviceClassId = ''
    deviceTypeList: any[] = []
    deviceCategoryOptions: any[] = []

    deviceSubTypeList: any[] = []

    // 高级密码计算所用日期，空表示按当天计算
    passwordDate = ""

    statusOptions = [{ label: "已启用", value: 1 }, { label: "已禁用", value: 0 }];

    currentPage = 1
    pageSize = 20
    isLoading = false
    hasMore = true
    searchTimer: any = null

    mounted() {
        document.title = '设备管理'
        this.loadDevices()
        this.getDeviceType()
        window.addEventListener('scroll', this.handleScroll)
    }

    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll)
        if (this.searchTimer) {
            clearTimeout(this.searchTimer)
        }
    }

    async loadDevices() {
        this.currentPage = 1
        this.hasMore = true
        this.devices = []
        await this.loadMoreDevices()
    }

    deviceFirstChange() {
        this.deviceClassId = "";
        this.deviceNameId = "";
        this.loadDevices()
    }
    async getDeviceType() {
        getDeviceTypeList({})
        .then((res) => {
            this.deviceTypeList = res.data;
        })
        .catch((err) => {});
    }

    getSubDeviceTypeList(key, parentId) {
        getSubDeviceTypeList({ parentId }).then((res) => {
        this[key] = res.data || [];
        }).catch(() => {
        this[key] = [];
        })
    }
    deviceClassNameChange($event) {
        this.deviceNameId = "";
        this.loadDevices()
    }

    getSearchDeviceTypeByParentId() {
        getDeviceTypeByParentId({
        mainTypeId: this.deviceTypeId,
        subTypeId: this.deviceClassId,
        }).then((res) => {
            this.deviceSubTypeList = res.data;
        })
        .catch((err) => {});
    }

    deviceNameChange() {
        this.$nextTick(() => {
            this.loadDevices()
        })
    }

    get filteredDevices() {
        // 搜索现在由后端处理，前端不再过滤
        return this.devices
    }

    get advancedPassword() {
        return getTcmBrainPassword(this.passwordDate)
    }

    handleSearch() {
        this.loadDevices()
    }

    handleSearchInput() {
        // 防抖搜索，避免频繁请求
        clearTimeout(this.searchTimer)
        this.searchTimer = setTimeout(() => {
            this.loadDevices()
        }, 500)
    }

    viewDeviceDetail(device: Device) {
        // 跳转到设备详情页，或显示详情
        console.log('查看设备详情', device)
    }

    editDevice(device: Device) {
        // 跳转到编辑页面
        const deviceData = encodeURIComponent(JSON.stringify(device))
        this.$router.push({
            name: 'H5DeviceEdit',
            params: { deviceData }
        })
    }

    addDevice() {
        // 跳转到新增页面
        this.$router.push({
            name: 'H5DeviceEdit'
        })
    }

    toggleDevice(device: Device) {
        // 切换设备启用/禁用状态
        console.log('切换设备状态', device)
        // 这里可以调用API更新状态
    }

    deviceTypeChange() {
        this.deviceClassId = ''
        this.loadDevices()
    }

    async loadMoreDevices() {
        if (this.isLoading || !this.hasMore) return

        this.isLoading = true
        try {
            const params: any = {
                pageNum: this.currentPage,
                pageSize: this.pageSize
            }
            params.deviceTypeId = this.deviceTypeId
            params.isEnable = this.isEnable
            params.deviceClassId = this.deviceClassId
            params.deviceNameId = this.deviceNameId
            params[this.searchKeyType] = this.searchKeyword

            const response = await deviceList(params)
            const newDevices = response.data.list || []
            
            if (newDevices.length < this.pageSize) {
                this.hasMore = false
            }
            
            this.devices = [...this.devices, ...newDevices]
            this.currentPage++
        } catch (error) {
            console.error('加载设备列表失败', error)
            this.$message.error('加载设备列表失败')
            this.hasMore = false // 加载失败时停止加载更多
        } finally {
            this.isLoading = false
        }
    }

    handleEnableState(row) {
        const content = row.enableState == 1 ? "禁用" : "启用";
        this.$confirm(`确认${content}该设备？`, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        center: true,
        }).then(() => {
        const params = {
            deviceId: row.id,
            status: row.enableState == 1 ? 0 : 1,
        };
        updateEnableState(params).then((res) => {
            this.handleSearch();
        })
        .catch((err) => {});
        });
    }

    handleScroll() {
        // 只有当有更多数据且没有正在加载时才检测触底
        if (!this.hasMore || this.isLoading) return

        const scrollTop = window.pageYOffset || document.documentElement.scrollTop
        const windowHeight = window.innerHeight
        const documentHeight = document.documentElement.scrollHeight

        // 只有当页面有足够内容可以滚动时才触发
        if (documentHeight > windowHeight && scrollTop + windowHeight >= documentHeight - 200) {
            this.loadMoreDevices()
        }
    }

    getSubType(subTypeObject) {
        return subTypeObject.deviceName + "[" + subTypeObject.runtime + "分钟]";
    }
}
